function getSpecsheetPublisher(specsheet = {}) {
  const publisher = specsheet.publisher;
  if (typeof publisher === "string" && publisher.trim()) {
    return publisher.trim();
  }
  if (publisher && typeof publisher === "object") {
    const publisherName = publisher.publisher || publisher.name || publisher.title;
    if (publisherName) return publisherName;
  }

  const titleParts = (specsheet.templateName || "")
    .split(/\s+-\s+/)
    .map((part) => part.trim())
    .filter(Boolean);

  return titleParts.length > 1 ? titleParts[1] : "Publisher";
}

function getSpecsheetNavigationLabel(specsheet = {}) {
  const {
    category,
    publisher,
    website,
    environment,
    section,
    device,
    templateName
  } = specsheet;
  const specsheetLabel = category.toLowerCase() === "publisher"
    ? `
      ${publisher} - 
      ${environment} - 
      ${device} - 
      ${(
        section !== ''
          ? `${section} - `
          : ''
      )}
      ${(
        website !== ''
          ? `${website} ${templateName}`
          : `${templateName}`
      )}
    `
    : `
      ${category} - 
      ${environment} - 
      ${device} - 
      ${(
        section !== ''
          ? `${section} - `
          : ''
      )}
      ${templateName}
    `;

  return specsheetLabel;
}

function getSpecsheetNavigationLink(specsheet = {}) {
  const { category, publisher, environment, section, templateName } = specsheet;
  const publisherEdit = publisher.replace(/\s+/g, "-");
  const environmentEdit = environment.replace(/\s+/g, "-");
  const sectionEdit = section.replace(/\s+/g, "-");
  const templateNameEdit = templateName.replace(/\s+/g, "-");

  const specsheetLabel = category.toLowerCase() === "publisher"
    ? `${publisherEdit}-${environmentEdit}-${sectionEdit}-${templateNameEdit}`
    : `${category}-${environmentEdit}-${sectionEdit}-${templateNameEdit}`;

  return specsheetLabel;
}

export { getSpecsheetPublisher, getSpecsheetNavigationLabel, getSpecsheetNavigationLink };
